import axios from "axios";
import { useEffect, useState } from "react";
import './history.css'
import Skeleton from '@mui/material/Skeleton';
import { getAuth } from "firebase/auth";
import { get } from "../../../Services/api";
import app_store from '../../../resources/app_store.png'

function BillingHistory({ billingData }) {
    const auth = getAuth();
    const [allInvoices, setAllInvoices] = useState([]);
    const [getDateDone, setGetDataDone] = useState(false)

    useEffect(() => {
        getAllInvoices()
    }, [billingData]);

    // get all invoices
    async function getAllInvoices() {
        if (billingData) {
            const idToken = await auth.currentUser?.getIdToken();
            const res = await get("/api/billing/stripe/get-all-customer-invoices?user_id=" + billingData.user_id, {
                headers: {
                    Authorization: idToken ? `Bearer ${idToken}` : undefined,
                }
            })
            setAllInvoices(res)
        }

        // Show data
        setGetDataDone(true)
    }

    function dateToString(date) {
        const options = {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        };

        return date.toLocaleString('en-US', options);
    }

    return (
        <div>
            <div className="billing_history_grid">
                <p className="font_weight_600 font_size_12 gray_scale_1">INVOICE</p>
                <p className="font_weight_600 font_size_12 gray_scale_1">STATUS</p>
                <p className="font_weight_600 font_size_12 gray_scale_1">AMOUNT</p>
                <p className="font_weight_600 font_size_12 gray_scale_1">DATE</p>
                <p></p>
            </div>
            <div className="billing_history_divider"></div>
            <div>
                {getDateDone ? allInvoices.map((invoice, i) => {
                    if (invoice.payment_provider_fk == 1)
                        return (<div>
                            <div className="billing_history_grid">
                                <img src={app_store} className='billing_history_app_store_icon' />
                                <p></p>
                                <p className="font_size_16">${invoice.price}</p>
                                <p className="font_size_16">{dateToString(new Date(invoice.created_date))}</p>
                                <a href={'https://www.apple.com/in/app-store/'} target="_blank" className="text_decoration_none">
                                    <p className="billing_history_invoice_view green_2">App Store</p>
                                </a>
                            </div>
                            {i != allInvoices.length - 1 ? <div className="billing_history_divider"></div> : null}
                        </div>)
                    else return (<div>
                        <div className="billing_history_grid">
                            <p className="font_size_16">{invoice.number}</p>
                            <p className="billing_history_invoice_status green_2 font_weight_600">{invoice.paid ? 'Paid' : 'Fail'}</p>
                            <p className="font_size_16">${invoice.amount_due / 100}</p>
                            <p className="font_size_16">{dateToString(new Date(invoice.created * 1000))}</p>
                            <a href={invoice.hosted_invoice_url} target="_blank" className="text_decoration_none">
                                <p className="billing_history_invoice_view green_2">view</p>
                            </a>
                        </div>
                        {i != allInvoices.length - 1 ? <div className="billing_history_divider"></div> : null}
                    </div>
                    )
                }) :
                    <div>
                        <div className="billing_history_grid">
                            <Skeleton variant="text" width={130} height={25} />
                            <Skeleton variant="rounded" width={70} height={20} />
                            <Skeleton variant="text" width={50} height={25} />
                            <Skeleton variant="text" width={200} height={25} />
                            <Skeleton variant="text" width={50} height={20} />
                        </div>
                    </div>
                }
            </div>
        </div>
    );
}


export default BillingHistory;